import React from 'react';
export function AboutSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-17" data-mp="3nndguzcdi347">
      <div className="max-w-3xl mx-auto text-center" data-id="element-18" data-mp="2lbn699ddxxkj">
        <h2 className="text-3xl font-black text-brand-text mb-8" data-id="element-19" data-mp="2la3qrkzjzqjt">
          A propósito de Yoga Lista
        </h2>
        <p className="text-lg text-brand-gray leading-relaxed" data-id="element-20" data-mp="2be0rqo000813">
          Nacimos con una misión clara: devolverle el tiempo y la paz mental a
          las profes de yoga de Argentina. Sabemos lo que es cruzar la ciudad de
          un estudio a otro, planificar clases a las 11 de la noche y sentir que
          el esfuerzo no rinde. Yoga Lista es el sistema que nos hubiera gustado
          tener cuando arrancamos.
        </p>
      </div>
    </section>;
}